<template>
  <div class="flex flex-col w-full mb-1">
    <data-field :label="$t('components.company.crm.keyEntered')">
      {{ propstackConfig.token?.length > 0 ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.keyValid')">
      {{ propstackConfig.isTokenVerified ? $t('components.company.crm.yes') : $t('components.company.crm.no') }}
    </data-field>
    <data-field :label="$t('components.company.crm.selectedStatuses')">
      {{ statuses }}
    </data-field>
  </div>
</template>

<script>
import PROPSTACK_CONFIG from '@/graphql/PropstackConfig.gql'
import PROPSTACK_CONTACT_STATUSES from '@/graphql/PropstackContactStatuses.gql'
import DataField from '@/components/data-field'

export default {
  components: {
    DataField
  },
  props: {
    companyId: { type: String, default: '' }
  },
  data () {
    return {
      propstackConfig: { selectedContactStatusIds: [] },
      contactStatuses: []
    }
  },
  computed: {
    statuses () {
      const contactStatusesMap = new Map([
        ...this.contactStatuses.map(status => [status.id, status.name]),
        ['ALL', this.$t('components.company.crm.allContacts')],
        ['UNDEFINED', this.$t('components.company.crm.contactsWithoutStatus')]
      ])
      return this.propstackConfig.selectedContactStatusIds.map(id => contactStatusesMap.get(id)).join(', ')
    }
  },
  apollo: {
    propstackConfig: {
      query: PROPSTACK_CONFIG,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    },
    contactStatuses: {
      query: PROPSTACK_CONTACT_STATUSES,
      variables () {
        return {
          companyId: this.companyId
        }
      }
    }
  }
}
</script>
